import { lensProp, over, pipe, map, find, propEq } from 'ramda'

const mapBookingProducts = products =>
  map(bp => {
    const product = find(propEq('Key', bp.ProductKey))(products)
    return { ...bp, isSegmentless: !product?.ActiveSegments?.length }
  })

export const setSegmentlessBools = products =>
  over(lensProp('BookingProducts'), mapBookingProducts(products))
